<app-create-password-form
  [title]="'completion_registration'"
  (submitForm)="completion($event)"
  [success]="success"
>
</app-create-password-form>
